import * as Types from '../../__generated__/api/types';

import gql from '@tv2-player/unifiedplayer/gqlToString';
export type UnifiedPlayerEntityFragmentBroadcast = {
  __typename: 'Broadcast';
  free: boolean | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  presentationArt: { __typename: 'Art'; url: string | null } | null;
  scalableLogo: { __typename: 'ScalableLogo'; regular: string };
  epgEntries: {
    __typename: 'EpgList';
    nodes: Array<{
      __typename: 'Epg';
      live: boolean | null;
      subPrograms: Array<{ __typename: 'Epg'; live: boolean | null } | null> | null;
    } | null> | null;
  } | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type UnifiedPlayerEntityFragmentEpisode = {
  __typename: 'Episode';
  duration: number | null;
  free: boolean | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  series: {
    __typename: 'Series';
    presentationTitle: string | null;
    presentationArt: { __typename: 'Art'; url: string | null } | null;
  } | null;
  parentalGuidance: {
    __typename: 'ParentalGuidance';
    parentalRatingImageInverted: string | null;
    voiceoverDescription: string | null;
  } | null;
  next: {
    __typename: 'Episode';
    type: Types.EntityType | null;
    guid: string;
    episodeNumber: number | null;
    seasonNumber: number | null;
    presentationTitle: string | null;
    presentationSubtitle: string | null;
    presentationArt: { __typename: 'Art'; url: string | null } | null;
    teaser: {
      __typename: 'EntityTeaser';
      label: {
        __typename: 'EntityLabel';
        text: string | null;
        backgroundColor: string | null;
      } | null;
    } | null;
  } | null;
  contentProvider: {
    __typename: 'ContentProvider';
    guid: string;
    title: string | null;
    broadcast: { __typename: 'Broadcast'; broadcastName: string | null } | null;
  } | null;
  genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type UnifiedPlayerEntityFragmentEvent = {
  __typename: 'Event';
  liveEvent: boolean | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  presentationArt: { __typename: 'Art'; url: string | null } | null;
  referred: {
    __typename: 'ReferredType';
    start: number | null;
    stop: number | null;
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type UnifiedPlayerEntityFragmentMovie = {
  __typename: 'Movie';
  free: boolean | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  art: {
    __typename: 'ArtList';
    nodes: Array<{
      __typename: 'Art';
      type: string | null;
      url: string | null;
      ratio: Types.ArtRatioType | null;
    } | null> | null;
  };
  parentalGuidance: {
    __typename: 'ParentalGuidance';
    parentalRatingImageInverted: string | null;
    voiceoverDescription: string | null;
  } | null;
  contentProvider: { __typename: 'ContentProvider'; guid: string; title: string | null } | null;
  genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type UnifiedPlayerEntityFragmentProgram = {
  __typename: 'Program';
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  presentationArt: { __typename: 'Art'; url: string | null } | null;
  parentalGuidance: {
    __typename: 'ParentalGuidance';
    parentalRatingImageInverted: string | null;
    voiceoverDescription: string | null;
  } | null;
  genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type UnifiedPlayerEntityFragmentSeries = {
  __typename: 'Series';
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type UnifiedPlayerEntityFragmentSportingEvent = {
  __typename: 'SportingEvent';
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type UnifiedPlayerEntityFragmentStation = {
  __typename: 'Station';
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type UnifiedPlayerEntityFragment =
  | UnifiedPlayerEntityFragmentBroadcast
  | UnifiedPlayerEntityFragmentEpisode
  | UnifiedPlayerEntityFragmentEvent
  | UnifiedPlayerEntityFragmentMovie
  | UnifiedPlayerEntityFragmentProgram
  | UnifiedPlayerEntityFragmentSeries
  | UnifiedPlayerEntityFragmentSportingEvent
  | UnifiedPlayerEntityFragmentStation;

export type UnifiedPlayerParentalGuidanceFragment = {
  __typename: 'ParentalGuidance';
  parentalRatingImageInverted: string | null;
  voiceoverDescription: string | null;
};

export type UnifiedPlayerNextFragment = {
  __typename: 'Episode';
  type: Types.EntityType | null;
  guid: string;
  episodeNumber: number | null;
  seasonNumber: number | null;
  presentationTitle: string | null;
  presentationSubtitle: string | null;
  presentationArt: { __typename: 'Art'; url: string | null } | null;
  teaser: {
    __typename: 'EntityTeaser';
    label: {
      __typename: 'EntityLabel';
      text: string | null;
      backgroundColor: string | null;
    } | null;
  } | null;
};

export type UnifiedPlayerPlaybackFragment = {
  __typename: 'Media';
  mediaType: string | null;
  duration: number | null;
  streams: Array<{
    __typename: 'Stream';
    format: Types.Format | null;
    url: string | null;
    capabilities: Array<{
      __typename: 'Capability';
      capabilityType: Types.CapabilityType | null;
      values: Array<string>;
    } | null>;
    drmLicense: { __typename: 'DrmLicense'; drm: Types.Drm; url: string; token: string } | null;
    ad: {
      __typename: 'Ad';
      vendor: Types.AdVendor | null;
      url: string | null;
      ppid: string | null;
      segmentation: string | null;
    } | null;
  } | null>;
  trickmode: {
    __typename: 'TrickMode';
    webVideoTextTracksFormatUrl: string | null;
    tiledThumbnailsUrl: string | null;
  } | null;
  subtitles: Array<{ __typename: 'Subtitle'; useAsDefault: boolean | null } | null>;
  concurrency: {
    __typename: 'Concurrency';
    updateInterval: number | null;
    httpMethod: string | null;
    url: string | null;
    body: {
      __typename: 'ConcurrencyBody';
      token: string | null;
      progress: number | null;
      guid: string | null;
      userAction: string | null;
      concurrencyAction: string | null;
    } | null;
  } | null;
};

export type UnifiedPlayerTrackingFragmentLiveTracking = {
  __typename: 'LiveTracking';
  adobe: {
    __typename: 'DetailedAdobeBlockList';
    nodes: Array<{
      __typename: 'DetailedAdobeBlock';
      program: {
        __typename: 'DetailedAdobe';
        id: string | null;
        title: string | null;
        duration: number | null;
        broadcast: string | null;
        type: string | null;
        ad: boolean | null;
        start: number | null;
        stop: number | null;
        startOverAvailable: boolean | null;
      } | null;
      prerolls: {
        __typename: 'DetailedAdobeList';
        nodes: Array<{
          __typename: 'DetailedAdobe';
          id: string | null;
          title: string | null;
          duration: number | null;
          broadcast: string | null;
          type: string | null;
          ad: boolean | null;
          start: number | null;
          stop: number | null;
        } | null> | null;
      } | null;
    } | null> | null;
    active: {
      __typename: 'DetailedAdobeBlock';
      program: {
        __typename: 'DetailedAdobe';
        id: string | null;
        title: string | null;
        duration: number | null;
        broadcast: string | null;
        type: string | null;
        ad: boolean | null;
        start: number | null;
        stop: number | null;
        startOverAvailable: boolean | null;
      } | null;
    } | null;
  } | null;
  nielsen: {
    __typename: 'DetailedNielsenList';
    nodes: Array<{
      __typename: 'DetailedNielsen';
      trackingObject: string | null;
      ad: boolean | null;
      start: number | null;
      stop: number | null;
    } | null> | null;
    active: {
      __typename: 'DetailedNielsen';
      trackingObject: string | null;
      ad: boolean | null;
      start: number | null;
      stop: number | null;
    } | null;
  } | null;
};

export type UnifiedPlayerTrackingFragmentVodTracking = {
  __typename: 'VodTracking';
  adobe: {
    __typename: 'Adobe';
    id: string;
    programTitle: string;
    title: string;
    seriesTitle: string | null;
    type: string;
    labels: string | null;
    category: string | null;
  } | null;
  nielsen: { __typename: 'Nielsen'; trackingObject: string | null } | null;
};

export type UnifiedPlayerTrackingFragment =
  | UnifiedPlayerTrackingFragmentLiveTracking
  | UnifiedPlayerTrackingFragmentVodTracking;

export type UnifiedPlayerLiveTrackingFragment = {
  __typename: 'LiveTracking';
  adobe: {
    __typename: 'DetailedAdobeBlockList';
    nodes: Array<{
      __typename: 'DetailedAdobeBlock';
      program: {
        __typename: 'DetailedAdobe';
        id: string | null;
        title: string | null;
        duration: number | null;
        broadcast: string | null;
        type: string | null;
        ad: boolean | null;
        start: number | null;
        stop: number | null;
        startOverAvailable: boolean | null;
      } | null;
      prerolls: {
        __typename: 'DetailedAdobeList';
        nodes: Array<{
          __typename: 'DetailedAdobe';
          id: string | null;
          title: string | null;
          duration: number | null;
          broadcast: string | null;
          type: string | null;
          ad: boolean | null;
          start: number | null;
          stop: number | null;
        } | null> | null;
      } | null;
    } | null> | null;
    active: {
      __typename: 'DetailedAdobeBlock';
      program: {
        __typename: 'DetailedAdobe';
        id: string | null;
        title: string | null;
        duration: number | null;
        broadcast: string | null;
        type: string | null;
        ad: boolean | null;
        start: number | null;
        stop: number | null;
        startOverAvailable: boolean | null;
      } | null;
    } | null;
  } | null;
  nielsen: {
    __typename: 'DetailedNielsenList';
    nodes: Array<{
      __typename: 'DetailedNielsen';
      trackingObject: string | null;
      ad: boolean | null;
      start: number | null;
      stop: number | null;
    } | null> | null;
    active: {
      __typename: 'DetailedNielsen';
      trackingObject: string | null;
      ad: boolean | null;
      start: number | null;
      stop: number | null;
    } | null;
  } | null;
};

export type UnifiedPlayerVodTrackingFragment = {
  __typename: 'VodTracking';
  adobe: {
    __typename: 'Adobe';
    id: string;
    programTitle: string;
    title: string;
    seriesTitle: string | null;
    type: string;
    labels: string | null;
    category: string | null;
  } | null;
  nielsen: { __typename: 'Nielsen'; trackingObject: string | null } | null;
};

export type UnifiedPlayerProgressFragment = {
  __typename: 'Progress';
  position: number | null;
  duration: number | null;
};

export type UnifiedPlayerUserRegionFragment = { __typename: 'Region'; name: string; value: string };

export const UnifiedPlayerParentalGuidanceFragment = gql`
  fragment UnifiedPlayerParentalGuidanceFragment on ParentalGuidance {
    parentalRatingImageInverted
    voiceoverDescription
  }
`;
export const UnifiedPlayerNextFragment = gql`
  fragment UnifiedPlayerNextFragment on Episode {
    type
    guid
    presentationArt {
      url
    }
    episodeNumber
    seasonNumber
    presentationTitle
    presentationSubtitle
    teaser {
      label {
        text
        backgroundColor
      }
    }
  }
`;
export const UnifiedPlayerEntityFragment = gql`
  fragment UnifiedPlayerEntityFragment on Entity {
    __typename
    guid
    type
    title
    presentationTitle
    referred {
      entity {
        __typename
        guid
      }
    }
    subtitle: presentationSubtitle
    references {
      web
    }
    teaser {
      watermark
    }
    ... on Broadcast {
      presentationArt {
        url
      }
      scalableLogo {
        regular
      }
      epgEntries {
        nodes {
          live
          subPrograms {
            live
          }
        }
      }
      free
    }
    ... on Event {
      presentationArt {
        url
      }
      referred {
        start
        stop
      }
      liveEvent
      genres {
        nodes
      }
      categories {
        nodes
      }
    }
    ... on Movie {
      art {
        nodes {
          type
          url
          ratio
        }
      }
      parentalGuidance {
        ...UnifiedPlayerParentalGuidanceFragment
      }
      contentProvider {
        guid
        title
      }
      free
      genres {
        nodes
      }
      categories {
        nodes
      }
    }
    ... on Episode {
      duration
      series {
        presentationArt {
          url
        }
        presentationTitle
      }
      parentalGuidance {
        ...UnifiedPlayerParentalGuidanceFragment
      }
      next {
        ...UnifiedPlayerNextFragment
      }
      contentProvider {
        guid
        title
        broadcast {
          broadcastName: title
        }
      }
      free
      genres {
        nodes
      }
      categories {
        nodes
      }
    }
    ... on Program {
      presentationArt {
        url
      }
      parentalGuidance {
        ...UnifiedPlayerParentalGuidanceFragment
      }
      genres {
        nodes
      }
      categories {
        nodes
      }
    }
  }
`;
export const UnifiedPlayerPlaybackFragment = gql`
  fragment UnifiedPlayerPlaybackFragment on Media {
    mediaType
    streams {
      format
      url
      capabilities {
        capabilityType
        values
      }
      drmLicense {
        drm
        url
        token
      }
      ad {
        vendor
        url
        ppid
        segmentation
      }
    }
    duration
    trickmode {
      webVideoTextTracksFormatUrl
      tiledThumbnailsUrl
    }
    subtitles {
      useAsDefault
    }
    concurrency {
      updateInterval
      httpMethod
      url
      body {
        token
        progress
        guid
        userAction
        concurrencyAction
      }
    }
  }
`;
export const UnifiedPlayerLiveTrackingFragment = gql`
  fragment UnifiedPlayerLiveTrackingFragment on LiveTracking {
    __typename
    adobe {
      nodes {
        program {
          id
          title
          duration
          broadcast
          type
          ad
          start
          stop
          startOverAvailable
        }
        prerolls {
          nodes {
            id
            title
            duration
            broadcast
            type
            ad
            start
            stop
          }
        }
      }
      active {
        program {
          id
          title
          duration
          broadcast
          type
          ad
          start
          stop
          startOverAvailable
        }
      }
    }
    nielsen {
      __typename
      nodes {
        trackingObject
        ad
        start
        stop
      }
      active {
        trackingObject
        ad
        start
        stop
      }
    }
  }
`;
export const UnifiedPlayerVodTrackingFragment = gql`
  fragment UnifiedPlayerVodTrackingFragment on VodTracking {
    __typename
    adobe {
      id
      programTitle
      title
      seriesTitle
      type
      labels
      category
    }
    nielsen {
      __typename
      trackingObject
    }
  }
`;
export const UnifiedPlayerTrackingFragment = gql`
  fragment UnifiedPlayerTrackingFragment on TrackingObject {
    __typename
    ...UnifiedPlayerLiveTrackingFragment
    ...UnifiedPlayerVodTrackingFragment
  }
`;
export const UnifiedPlayerProgressFragment = gql`
  fragment UnifiedPlayerProgressFragment on Progress {
    position
    duration
  }
`;
export const UnifiedPlayerUserRegionFragment = gql`
  fragment UnifiedPlayerUserRegionFragment on Region {
    name
    value
  }
`;
